import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APP_FILE_EVENTS_ROUTE } from "./events.constants";
const Events = Loadable(
  lazy(() =>
	import("./events").then(({ Events }) => ({
	  default: Events,
	}))
  )
);

export const eventsRoutes = [
  {
	path: `${APP_FILE_EVENTS_ROUTE}`,
	exact: true,
	element: (
	  <AuthorizedRoute allowFullAccess moduleKeys={[]}>
		<Events />
	  </AuthorizedRoute>
	),
  },
 
];
